import { ITemplateScope } from "AngularFormly";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../../../records/grids/columns/columnDefinitionService";
import { IRowCommandEventArgs } from "../../../../../records/grids/controller";
import {
  MachineSelectEventArgs,
  SelectMachineModalService,
  vsServiceName as selectMachineModalServiceName,
} from "../../../components/selectMachineModal";
import { MachineConfigurationView } from "../../../models/machineConfiguration";

interface FormlyTypeSelectMachineScope extends ITemplateScope {
  openMachineModal: () => void;
}

export class FormlyTypeSelectMachineController {
  static $inject = [
    selectMachineModalServiceName,
    "$scope",
    ColumnDefinitionServiceName,
  ];

  private modalService: angular.ui.bootstrap.IModalInstanceService | undefined;
  constructor(
    private readonly selectMachineModalService: SelectMachineModalService,
    private readonly $scope: FormlyTypeSelectMachineScope,
    private readonly columnDefinitionService: ColumnDefinitionService
  ) {
    this.$scope.openMachineModal = () => this.openMachineModal();
  }

  openMachineModal() {
    this.modalService = this.selectMachineModalService.openModal({
      additionalColumns: [
        this.columnDefinitionService.getCommandColDef({
          headerName: "select",
          iconClass: "fa fa-plus-circle text-primary",
          name: "select",
          width: 20,
        }),
      ],
      defaultQuery: { CurrentConfiguration: true },
      onItemCommand: (args: IRowCommandEventArgs<MachineConfigurationView>) => {
        this.onMachineSelected({ machine: args.data });
      },
    });

    this.modalService.result.then((args: MachineSelectEventArgs) => {
      const model = this.$scope.model;
      if (!model) return;
      model[this.$scope.options.key] = {
        ...args.machine,
      };
    });
  }

  onMachineSelected(args: MachineSelectEventArgs): void {
    if (!this.$scope.model) return;
    this.modalService?.close(args);
  }
}
